/**
 * Created by mkoehler on 01.02.16.
 */
import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.FadeToggler = function (element) {
        this.$fader = $(element);
        this.$togglerContent = $('.togglerContent', this.$fader);
        this.$togglerHead = $('.togglerHead', this.$fader);

        this.$window = $(window);

        this.init();
    };

    OndigoNS.FadeToggler.prototype = {
        init: function () {
            var _instance = this,
                oldHeight = this.$togglerContent.css('height');

            if (OndigoNS.Utils.hasTouchscreen()) {
                this.$window.on('orientationchange', function () {
                    setTimeout(function () {
                        oldHeight = _instance.$togglerContent.css('height');
                    }, 100);
                });
            }
            else {
                this.$window.on('resize', function () {
                    setTimeout(function () {
                        oldHeight = _instance.$togglerContent.css('height');
                    }, 100);
                });
            }

            this.$togglerHead.on('click', function () {
                if(_instance.$fader.hasClass('displayAsNormalCeOnTablet')) {
                    if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                        _instance.handleToggleClick(oldHeight);
                    }
                } else if(_instance.$fader.hasClass('displayAsNormalCeOnDesktop')) {
                    if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                        _instance.handleToggleClick(oldHeight);
                    }
                } else {
                    _instance.handleToggleClick(oldHeight);
                }
            });
        },
        handleToggleClick : function (oldHeight) {
            var _instance = this,
                textHeight = 0;

            if(this.$fader.hasClass('open')) {
                this.$togglerContent.animate({
                    height: oldHeight
                }, 400, function () {
                    _instance.$fader.removeClass('open');
                });
            } else {
                this.$togglerContent.css('height', 'auto');
                textHeight = this.$togglerContent.height();
                this.$togglerContent.css('height', oldHeight);

                this.$fader.addClass('open');
                this.$togglerContent.animate({
                    height: textHeight
                });
            }
        }
    };

    // plugin definition
    $.fn.initFadeToggler = function () {
        return new OndigoNS.FadeToggler(this);
    };
    $.fn.initFadeToggler.Constructor = OndigoNS.FadeToggler;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    var $fader = $('.fadeToggler');

    if ($fader.length) {
        $.each($fader, function () {
            $(this).initFadeToggler();
        });
    }
});
